<script>
  export default {
    props: {
      value: { type: Number, default: 0 },
      texto: { type: String, default: '' },
      placeholder: { type: String, default: 'Digite para buscar...' },
      buscar: { type: Function, required: true },
      desabilitado: { type: Boolean, default: false },
      abrirAoFocar: { type: Boolean, default: true },
      autoUnico: { type: Boolean, default: false },
    },
    data() {
      return {
        termo: this.texto || '',
        opcoes: [],
        aberto: false,
        carregando: false,
        timer: null,
        estilo: {},
      }
    },
    watch: {
      texto(valor) { if (!this.aberto) this.termo = valor || ''; },
      aberto(valor) {
        if (valor) {
          this.posicionar();
          window.addEventListener('scroll', this.posicionar, true);
          window.addEventListener('resize', this.posicionar);
          return;
        }
        window.removeEventListener('scroll', this.posicionar, true);
        window.removeEventListener('resize', this.posicionar);
      },
    },
    methods: {
      posicionar() {
        const campo = this.$refs.campo;
        if (!campo) return;

        const r = campo.getBoundingClientRect();
        const espacoAbaixo = window.innerHeight - r.bottom;
        const altura = Math.max(140, Math.min(240, espacoAbaixo - 12));
        const paraCima = espacoAbaixo < 160 && r.top > espacoAbaixo;

        this.estilo = paraCima
          ? { left: r.left + 'px', width: r.width + 'px', bottom: (window.innerHeight - r.top + 2) + 'px', maxHeight: Math.min(240, r.top - 12) + 'px' }
          : { left: r.left + 'px', width: r.width + 'px', top: (r.bottom + 2) + 'px', maxHeight: altura + 'px' };
      },
      aoDigitar() {
        this.aberto = true;
        this.$nextTick(() => this.posicionar());
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.carregar(), 300);
      },
      aoFocar() {
        if (!this.abrirAoFocar || this.desabilitado) return;
        this.aberto = true;
        this.$nextTick(() => this.posicionar());
        if (this.opcoes.length === 0) this.carregar();
      },
      carregar() {
        this.carregando = true;
        this.buscar(this.termo || '')
          .then(opcoes => {
            this.opcoes = opcoes || [];
            this.carregando = false;
            this.$nextTick(() => this.posicionar());
            if (this.autoUnico && this.value <= 0 && this.opcoes.length === 1) this.selecionar(this.opcoes[0]);
          })
          .catch(() => { this.opcoes = []; this.carregando = false; });
      },
      preencherSeUnico() {
        if (this.desabilitado || this.value > 0) return;

        this.buscar('')
          .then(opcoes => {
            if ((opcoes || []).length !== 1) return;
            this.opcoes = opcoes;
            this.selecionar(opcoes[0]);
          })
          .catch(() => {});
      },
      selecionar(opcao) {
        this.termo = opcao.nome;
        this.aberto = false;
        this.$emit('input', opcao.id);
        this.$emit('selecionado', opcao);
      },
      limpar() {
        this.termo = '';
        this.opcoes = [];
        this.aberto = false;
        this.$emit('input', 0);
        this.$emit('selecionado', null);
      },
      fechar() {
        setTimeout(() => { this.aberto = false; }, 180);
      },
    },
    beforeDestroy() {
      clearTimeout(this.timer);
      window.removeEventListener('scroll', this.posicionar, true);
      window.removeEventListener('resize', this.posicionar);
    },
    template: `
      <div class="sel-busca">
        <div class="sel-campo" ref="campo">
          <input type="text" class="form-control" :placeholder="placeholder" :disabled="desabilitado"
                 v-model="termo" @input="aoDigitar" @focus="aoFocar" @blur="fechar">
          <a v-if="value > 0 && !desabilitado" href="#" class="sel-limpar" title="Limpar" @mousedown.prevent="limpar"><i class="fa fa-times"></i></a>
        </div>
        <div v-if="aberto" class="sel-lista" :style="estilo">
          <div v-if="carregando" class="sel-item sel-vazio"><i class="fa fa-spinner fa-pulse"></i> Buscando...</div>
          <template v-else>
            <a v-for="o in opcoes" :key="o.id" href="#" class="sel-item" @mousedown.prevent="selecionar(o)">
              <span class="sel-nome">{{ o.nome }}</span>
              <small v-if="o.complemento" class="sel-comp">{{ o.complemento }}</small>
            </a>
            <div v-if="opcoes.length === 0" class="sel-item sel-vazio">Nenhum registro encontrado</div>
          </template>
        </div>
      </div>`,
  }
</script>

<style scoped>
  .sel-busca { position: relative; }
  .sel-campo { position: relative; }
  .sel-campo .form-control { padding-right: 26px; }
  .sel-limpar { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); color: #a4acb4; font-size: 12px; }
  .sel-limpar:hover { color: #6b747e; }
  .sel-lista { position: fixed; z-index: 3200; overflow: auto; background: #fff; border: 1px solid #d3d8de; border-radius: 5px; box-shadow: 0 6px 18px rgba(16,24,40,.14); }
  .sel-item { display: block; padding: 7px 10px; font-size: 13px; color: #1c2024; border-bottom: 1px solid #eef1f4; }
  .sel-item:last-child { border-bottom: none; }
  .sel-item:hover { background: #f4f6f8; }
  .sel-nome { display: block; }
  .sel-comp { color: #8a939c; font-size: 11.5px; }
  .sel-vazio { color: #8a939c; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/SelecaoBusca.vue